// @ts-nocheck
import { replaceAllNotDigitsTextCursor } from '../replaceWithCursorPosition';

export class MaskDare {
  public insertIconValidate = true;

  public validateAllDigit = false;

  public maxLength = 19;

  constructor(_view: any, public assets: any) {}

  public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
    const { newValue, newCursorPosition } = replaceAllNotDigitsTextCursor(value, cursorPosition);

    if (newValue.length > this.maxLength) {
      return {
        newValue: newValue.substr(0, this.maxLength),
        newCursorPosition: newCursorPosition >= this.maxLength ? this.maxLength : newCursorPosition,
      };
    }

    return { newValue, newCursorPosition };
  }

  public setMask(value: string, cursorPosition): { formatedValue; formatedCursorPosition } {
    try {
      if (value.length <= 15) {
        return { formatedValue: value, formatedCursorPosition: cursorPosition };
      } else {
        const formatedValue = value.replace(/^(\d{15})(\d{1,4})$/, '$1-$2');
        const formatedCursorPosition = cursorPosition < 15 ? cursorPosition : cursorPosition + 1;

        return { formatedValue, formatedCursorPosition: formatedCursorPosition };
      }
    } catch (err) {
      console.error('Error: ', err);
      return { formatedValue: value, formatedCursorPosition: cursorPosition };
    }
  }

  public validate(value) {
    if (value.length !== 20) return false;
    return true;
  }

  public getMaskErrors() {
    return [this.assets.labels.feedbacks.masks['DARE']];
  }
}
